import { dashboardAsyncRequestManagerListRequests } from "../dashboardAsyncRequestManagerListRequests";
import type { AllRouteEndpoints } from "../routeTypes";
export const dashboardAsyncRequestManagerCancelRequestCacheKeys: AllRouteEndpoints[] = [
  dashboardAsyncRequestManagerListRequests,
];
